module.exports = __webpack_public_path__ + "static/media/logo.a35c834c.png";